import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getBusinessLounge } from '@websky/core/src/Checkout/store/order/selectors';
import BusinessService from '../BusinessService/BusinessService';
const Business = () => {
    const { t } = useTranslation('Checkout');
    const businessLoungeServices = useSelector(getBusinessLounge);
    const servicesByRfics = React.useMemo(() => {
        const servicesByRficsMap = new Map();
        businessLoungeServices.forEach(service => {
            var _a;
            const key = service.rfisc;
            servicesByRficsMap.set(key, [...((_a = servicesByRficsMap.get(key)) !== null && _a !== void 0 ? _a : []), service]);
        });
        return [...servicesByRficsMap.values()];
    }, [businessLoungeServices]);
    if (!businessLoungeServices.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null, servicesByRfics.map(services => {
        var _a;
        const service = services[0];
        return (React.createElement(BusinessService, { key: service.id, header: (_a = service.name) !== null && _a !== void 0 ? _a : t('Business lounge'), service: service }));
    })));
};
export default Business;
